import React from "react";
import { bodyCodingBenefits } from "../../../data/body-coding/body-coding-benefits";
import { motion } from "framer-motion";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import Chip from "../../shared/Chip";
import { 
    FaHeart, 
    FaDove, 
    FaLeaf, 
    FaStar, 
    FaGem,
    FaInfinity
} from "react-icons/fa";
import { GiScales, GiButterfly } from "react-icons/gi";

const BodyCodingBenefits = () => {
    const { ref, isIntersecting: isVisible } = useIntersectionObserver({ threshold: 0.1 });

    // Map benefits to icons
    const benefitData = [
        { text: bodyCodingBenefits.content[0], icon: FaGem },
        { text: bodyCodingBenefits.content[1], icon: GiScales },
        { text: bodyCodingBenefits.content[2], icon: FaDove },
        { text: bodyCodingBenefits.content[3], icon: FaHeart },
        { text: bodyCodingBenefits.content[4], icon: FaLeaf },
        { text: bodyCodingBenefits.content[5], icon: FaStar },
        { text: bodyCodingBenefits.content[6], icon: FaInfinity },
        { text: bodyCodingBenefits.content[7], icon: GiButterfly },
    ];

    return (
        <div className="px-1 px-md-5" ref={ref}>
            <motion.h2 
                className="text-md-center fw-bold display-5 mb-3 mb-md-5 pb-5 ms-3 ms-md-0"
                initial={{ opacity: 0, y: 30 }}
                animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                transition={{ duration: 0.6 }}
            >
                {bodyCodingBenefits.heading}
            </motion.h2>
            <div className="d-flex justify-content-center flex-wrap px-1 px-md-5" style={{ 
                gap: '10px'
            }}>
                {benefitData.map((benefit, index) => (
                    <Chip 
                        key={index}
                        text={benefit.text} 
                        icon={benefit.icon}
                        whileHover={{ 
                            scale: 1.02, 
                            y: -1,
                            transition: { duration: 0.15 }
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default BodyCodingBenefits;